// frontend/src/manager_notifications/notificationTypes.js

/**
 * Types de notifications centralisés
 * Ajoutez un nouveau type ici et il sera automatiquement disponible partout
 */

export const NOTIFICATION_TYPES = {
  // Événements planning
  FLIGHT: { id: 'flight', label: 'Vol', icon: 'Plane', category: 'schedule', defaultPriority: 'high' },
  FUEL: { id: 'fuel', label: 'Carburant', icon: 'Fuel', category: 'schedule', defaultPriority: 'normal' },
  MAINTENANCE: { id: 'maintenance', label: 'Maintenance', icon: 'Wrench', category: 'schedule', defaultPriority: 'high' },
  MEETING: { id: 'meeting', label: 'Réunion', icon: 'Users', category: 'schedule', defaultPriority: 'normal' },
  APPOINTMENT: { id: 'appointment', label: 'Rendez-vous', icon: 'Calendar', category: 'schedule', defaultPriority: 'normal' },
  
  // Alertes
  EMERGENCY_ALERT: { id: 'emergency', label: 'Urgence', icon: 'AlertTriangle', category: 'alert', defaultPriority: 'critical' },
  WARNING_ALERT: { id: 'warning', label: 'Alerte', icon: 'AlertTriangle', category: 'alert', defaultPriority: 'high' },
  INFO_ALERT: { id: 'info', label: 'Information', icon: 'Bell', category: 'alert', defaultPriority: 'low' },
  SUCCESS_ALERT: { id: 'success', label: 'Succès', icon: 'CheckCircle', category: 'alert', defaultPriority: 'normal' },
  
  // Messages chat
  CHAT_MESSAGE: { id: 'chat', label: 'Message', icon: 'MessageSquare', category: 'chat', defaultPriority: 'normal' },
  APPOINTMENT_REQUEST: { id: 'appointment_request', label: 'Demande RDV', icon: 'Calendar', category: 'chat', defaultPriority: 'high' },
  APPOINTMENT_RESPONSE: { id: 'appointment_response', label: 'Réponse RDV', icon: 'CheckCircle', category: 'chat', defaultPriority: 'normal' },
  
  // Demandes clients (fuel, maintenance)
  FUEL_REQUEST: { id: 'fuel_request', label: 'Demande carburant', icon: 'Fuel', category: 'request', defaultPriority: 'high' },
  MAINTENANCE_REQUEST: { id: 'maintenance_request', label: 'Demande maintenance', icon: 'Wrench', category: 'request', defaultPriority: 'high' },
  
  // Système
  SYSTEM_NOTIFICATION: { id: 'system', label: 'Système', icon: 'Settings', category: 'system', defaultPriority: 'low' }
};

export const NOTIFICATION_CATEGORIES = {
  schedule: { label: 'Planning', color: 'blue', order: 1 },
  alert: { label: 'Alertes', color: 'red', order: 0 },
  chat: { label: 'Chat', color: 'green', order: 2 },
  request: { label: 'Demandes clients', color: 'orange', order: 0 },
  system: { label: 'Système', color: 'gray', order: 3 }
};

export const PRIORITY_LEVELS = {
  critical: { label: 'CRITIQUE', color: 'red', weight: 0, icon: 'AlertTriangle' },
  high: { label: 'HAUTE', color: 'orange', weight: 1, icon: 'AlertCircle' },
  normal: { label: 'NORMALE', color: 'blue', weight: 2, icon: 'Bell' },
  low: { label: 'BASSE', color: 'gray', weight: 3, icon: 'Info' }
};

// Statuts pour les demandes clients
export const REQUEST_STATUS = {
  pending: { label: 'En attente', color: 'yellow', icon: 'Clock' },
  approved: { label: 'Approuvé', color: 'green', icon: 'CheckCircle' },
  rejected: { label: 'Refusé', color: 'red', icon: 'XCircle' },
  completed: { label: 'Terminé', color: 'blue', icon: 'CheckCircle' },
  cancelled: { label: 'Annulé', color: 'gray', icon: 'XCircle' }
};

// Actions possibles sur les demandes
export const REQUEST_ACTIONS = {
  approve: { label: 'Approuver', color: 'green', icon: 'CheckCircle' },
  reject: { label: 'Refuser', color: 'red', icon: 'XCircle' },
  complete: { label: 'Terminer', color: 'blue', icon: 'CheckCircle' }
};

// Mapping des statuts pour les événements
export const STATUS_CONFIG = {
  check_in: { label: 'Check-in', icon: 'CheckCircle', color: 'green' },
  check_out: { label: 'Check-out', icon: 'XCircle', color: 'red' },
  billing: { label: 'Facturation', icon: 'DollarSign', color: 'yellow' },
  grading: { label: 'Évaluation', icon: 'FileText', color: 'blue' },
  squawk: { label: 'Squawk', icon: 'AlertCircle', color: 'orange' }
};

// Règles de filtrage par défaut
export const DEFAULT_FILTERS = {
  maxAge: 7, // jours
  includeCompleted: false,
  minPriority: 'low',
  categories: ['schedule', 'alert', 'chat', 'request', 'system']
};

// Configuration des couleurs par type d'événement
export const EVENT_COLORS = {
  flight: 'blue',
  fuel: 'orange',
  maintenance: 'red',
  meeting: 'purple',
  appointment: 'green'
};